import React from 'react';

const InvoiceDetail = () => {
  return (
    <div className="card p-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
        Invoice Detail
      </h1>
      <p className="text-gray-600 dark:text-gray-400">
        Invoice detail functionality will be implemented here.
      </p>
    </div>
  );
};

export default InvoiceDetail;
